




























import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import ScaleView from 'components/ScaleView.vue'
import SlideView from 'components/presenter/item/topic/viewer/View.vue'
import FormSlide from 'components/presenter/item/topic/editor/FormSlide.vue'
import FormImage from 'components/presenter/item/topic/editor/FormImage.vue'
import FormMovie from 'components/presenter/item/topic/editor/FormMovie.vue'
import FormChoice from 'components/presenter/item/topic/editor/FormChoice.vue'
import FormYesNo from 'components/presenter/item/topic/editor/FormYesNo.vue'
import FormOrder from 'components/presenter/item/topic/editor/FormOrder.vue'
import FormNumber from 'components/presenter/item/topic/editor/FormNumber.vue'
import FormGaps from 'components/presenter/item/topic/editor/FormGaps.vue'
import FormEssay from 'components/presenter/item/topic/editor/FormEssay.vue'
import FormVote from 'components/presenter/item/topic/editor/FormVote.vue'
import FormRate from 'components/presenter/item/topic/editor/FormRate.vue'
import FormOpen from 'components/presenter/item/topic/editor/FormOpen.vue'
import MarkdownViewerCrdt from 'components/MarkdownViewerCrdt.vue'
import { Item } from 'src/graphql/types'

@Component({
  components: {
    ScaleView,
    SlideView,
    FormSlide,
    FormImage,
    FormMovie,
    FormChoice,
    FormYesNo,
    FormOrder,
    FormNumber,
    FormGaps,
    FormEssay,
    FormVote,
    FormRate,
    FormOpen,
    MarkdownViewerCrdt
  }
})
export default class ItemTopicSlidesEditorForm extends Vue {
  preview: boolean = false
  editor = ''
  viewer = ''

  @Prop()
  readonly item!: Item

  @Prop()
  readonly slides!: Json[]

  @Prop()
  readonly slide!: Json

  @Prop()
  readonly corrects!: Json

  @Watch('slide', { immediate: true})
  init (slide: Json) {
    this.editor = 'Form' + slide.type
    this.viewer = 'View' + slide.type
  }
}
